import { Locales } from '@ratehub/base-ui';
import { PAGE_TEMPLATES } from '@ratehub/web-components';

import BLOCK_MAP from '../definitions/TemplateMortgageAgentsListBlockMap';
import withFrenchLocale from '../functions/withFrenchLocale';
import createWordpressPageStaticProps from '../functions/createWordpressPageStaticProps';
import createStaticWordpressPage from '../functions/createStaticWordpressPage';


const { getStaticPaths, getStaticProps } = createWordpressPageStaticProps({
    locale: Locales.FRENCH,
    fileName: 'wordpressMortgageAgentsListFR', // Must match filename use for catch all, i.e. [...ccDetailsSlugEN].jsx
    blockMap: BLOCK_MAP,
    template: PAGE_TEMPLATES.mtgAgentsList,
});

const page = createStaticWordpressPage({ blockMap: BLOCK_MAP });

export default withFrenchLocale(page);
export { getStaticPaths, getStaticProps, BLOCK_MAP };
